module.exports = __webpack_public_path__ + "static/media/md-pricetags.ae695e87.svg";